<template>
  <div class="creator-center-container" :style="{
    'margin-top': cc.margin_top + 'px' || gc.margin_top + 'px',
    'margin-bottom': cc.margin_bot + 'px' || gc.margin_bot + 'px',
  }">
    <div class="swiper-container user-list-wrap">
      <div class="swiper-wrapper">
        <div class="swiper-slide" v-for="(page, i) in follow_user_list" :key="i">
          <div 
          class="user-item box-wrapper" 
          v-for="(user, index) in page" 
          :key="user.username" 
          @click="openUserPage(user)"
          :style="{
            'background': cc.bg_img ? `url(${cc.bg_img}) no-repeat center/contain` : cc.bg_color || '#FFF',
            'border-radius': cc.border_radius + 'px',
            'border': `${cc.border_width || 0}px solid ${cc.border_color || '#000'}`
          }"
          >
            <div class="wrap">
              <div class="avatar-box" :style="{'border-color': gc.main_color}">
                <img :src="user.avatar" alt="">
              </div>
              <p class="username" :style="{'color': gc.main_color}">{{user.username}}</p>
              <p class="desc" :style="{'color': gc.main_color}">{{user.desc}}</p>
              <div class="follow-box" :class="{'is-follow': user.state == 1}" :style="{'background': cc.follow_btn ? `url(${cc.follow_btn}) center center/cover no-repeat` : gc.main_color, 'border-radius': cc.follow_btn ? '' : '4px'}" @click.stop="followUser(user, i, index)">
                <svg v-if="user.state == 1" width="12" height="8" viewBox="0 0 12 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M0.263992 4C-0.0879975 3.65559 -0.0879975 3.09718 0.263992 2.75277C0.615982 2.40836 1.18667 2.40836 1.53866 2.75277L4.72469 5.87022L10.4613 0.25831C10.8133 -0.0861033 11.384 -0.0861033 11.736 0.25831C12.088 0.602723 12.088 1.16113 11.736 1.50554L5.36267 7.74169C5.01068 8.0861 4.43999 8.0861 4.088 7.74169L0.263992 4Z" :fill="gc.text_color"/>
                </svg>
                <svg v-else width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M7 1C7 0.447715 6.55228 0 6 0C5.44772 0 5 0.447715 5 1V5H1C0.447715 5 0 5.44772 0 6C0 6.55228 0.447715 7 1 7H5V11C5 11.5523 5.44772 12 6 12C6.55228 12 7 11.5523 7 11V7H11C11.5523 7 12 6.55228 12 6C12 5.44772 11.5523 5 11 5H7V1Z" :fill="gc.text_color"/>
                </svg>
                <div class="btn-follow" :style="{'color': gc.text_color,}">{{user.state == 1 ? '已' : ''}}关注</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
     <div class="user-pagination">
      <div
        class="pagination-item" :class="{'on': user_index == index}" 
        :style="{'background-color': user_index == index ? gc.main_color : hexToRgba(gc.main_color, .4)}"
        v-for="(item, index) in follow_user_list" :key="index">
      </div>
    </div>
  </div>
</template>

<script>
import { utils } from '_lib/utils'
import { ComponentCommonMixin } from '../mixin'
import Swiper from 'swiper'
import 'swiper/swiper-bundle.css'
import { followUser } from '_api/activity-common-template'
export default {
  mixins: [ComponentCommonMixin],
  data () {
    return {
      follow_user_list: [],
      user_index: 0,
      user_lock: false
    }
  },
  mounted () {
    this.setFollowUserList(this.cd.follow_user_list)
    setTimeout(() => {
      this.setSwiper()
    })
  },
  methods: {
    followUser (user, i, index) {
      if (!this.is_in_heybox) {
        this.openInHeybox()
        return
      }
      if (this.user_lock) {
        return
      }
      this.user_lock = true
      const id = user.heybox_id || user.userid || user.user_id
      let url = ''
      let desc = '关注成功！'
      if (user.state == 1) {
        url = '/bbs/app/profile/follow/user/cancel'
        desc = '取消关注成功！'
      } else {
        url = '/bbs/app/profile/follow/user'
      }
      followUser(url, {
        heybox_id: this.querys.heybox_id,
        os_type: 'webinapp',
        task_os_type: this.querys.task_os_type
      }, {
        following_id: id
      }).then((res) => {
        this.user_lock = false
        if (res.data.status == 'ok') {
          this.$set(this.follow_user_list[i][index], 'state', ~this.follow_user_list[i][index].state+2)
          this.setFollowUserList(this.follow_user_list, false)
          utils.showMessage('ok', desc)
        } else {
          utils.showMessage('failed', res.data.msg || '操作失败')
        }
      })
    },
    openUserPage (user) {
      if (!this.is_in_heybox) {
        this.openInHeybox()
        return
      }
      var id = user.heybox_id || user.userid || user.user_id
      this.reportData('.' + id)
      utils.executeProtocol({
        protocol_type: 'openUser',
        user_id: id
      })
    },
    setFollowUserList (_list, isInit = true) {
      var list = []
      _list.forEach((_item) => {
        if (Object.prototype.toString.call(_item) === "[object Array]") {
          list = list.concat(_item)
        } else {
          list.push(_item)
        }
      })
      var unfollow_list = []
      var followed_list = []
      list.forEach((item) => {
        if (item.state == 0) {
          unfollow_list.push(item)
        } else {
          followed_list.push(item)
        }
      })
      var user_arr = []
      var user_index = 0
      var user_len = 3
      if (isInit) {
        list = this.shuffle(unfollow_list).concat(this.shuffle(followed_list))
      } else {
        list = unfollow_list.concat(followed_list)
      }
      list.forEach((item) => {
        if (!user_arr[user_index]) {
          user_arr[user_index] = []
        }
        if (user_arr[user_index].length < user_len) {
          user_arr[user_index].push(item)
        }
        if (user_arr[user_index].length == user_len) {
          user_index++
        }
      })
      this.follow_user_list = user_arr
    },
    shuffle (arr) {
      let _arr = arr.slice();
      for (let i = 0; i<_arr.length; i++){
        let j = this.getRandomInt(0,i);
        let t = _arr[i];
        _arr[i] = _arr[j];
        _arr[j] = t;
      }
      return _arr;
    },
    getRandomInt (min, max) {
      return Math.floor(Math.random() * (max - min + 1)) + min
    },
    setSwiper () {
      var _this = this
      this.userSwiper = new Swiper('.user-list-wrap', {
        on: {
          slideChange (swiper) {
            _this.user_index = swiper.activeIndex
          }
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.creator-center-container {
  margin: 30px 14px;
  .user-pagination {
    height: 38px;
    padding-bottom: 6px;
    display: flex;
    justify-content: center;
    align-items: center;
    .pagination-item {
      width: 6px;
      height: 6px;
      border-radius: 3px;
      margin: 0 5px;
    }
  }
  .user-list-wrap {
    width: 100%;
    height: 141px;
    margin-top: 18px;
    .swiper-slide {
      display: flex;
    }
    .user-item {
      width: calc((100% - 20px) / 3);
      height: 141px;
      margin-left: 10px;
      &:first-of-type {
        margin-left: 0;
      }
      .wrap {
        height: 100%;
        padding: 10px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        .avatar-box {
          width: 50px;
          height: 50px;
          border: 2px solid;
          border-radius: 50%;
          overflow: hidden;
          img {
            width: 100%;
            height: 100%;
            display: block;
          }
        }
        .username {
          width: 100%;
          line-height: 17px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          margin-top: 4px;
          font-size: 12px;
          text-align: center;
        }
        .desc {
          width: 100%;
          line-height: 14px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          margin-top: 2px;
          font-size: 10px;
          text-align: center;
          opacity: .8;
        }
        .follow-box {
          display: flex;
          align-items: center;
          justify-content: center;
          height: 24px;
          width: 64px;
          margin-top: 10px;
          background-repeat: no-repeat;
          background-size: 100% auto;
          &.is-follow {
            opacity: .5;
          }
          svg {
            margin-right: 4px;
          }
          .btn-follow {
            font-size: 12px;
            line-height: 17px;
          }
        }
      }
    }
  }
}
</style>